import { useNavigate } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { AicostrMark } from '@/components/icons/AicostrMark';

export function LandingFooter() {
  const navigate = useNavigate();

  return (
    <footer className="border-t border-hairline py-10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 text-xs text-muted-foreground sm:flex-row sm:px-6 lg:px-8">
        <div className="flex items-center gap-2">
          <AicostrMark size={24} />
          <span className="font-medium text-foreground">
            <span className="text-primary">ai</span>costr
          </span>
          <span aria-hidden>·</span>
          <span>© {new Date().getFullYear()}</span>
        </div>

        <div className="flex items-center gap-5">
          <a
            href="#"
            className="transition-colors hover:text-foreground"
            onClick={(e) => {
              e.preventDefault();
              navigate('/blog');
            }}
          >
            Blog
          </a>
          <a
            href="https://github.com/Vinodmurkute/ai-cost-guard"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-foreground"
          >
            GitHub
          </a>
          <a
            href="#"
            className="transition-colors hover:text-foreground"
            onClick={(e) => {
              e.preventDefault();
              navigate('/privacy');
            }}
          >
            Privacy
          </a>
          <a
            href="#"
            className="transition-colors hover:text-foreground"
            onClick={(e) => {
              e.preventDefault();
              navigate('/terms');
            }}
          >
            Terms
          </a>
          <a
            href="#"
            className="inline-flex items-center gap-1 transition-colors hover:text-foreground"
            onClick={(e) => {
              e.preventDefault();
              document
                .querySelector('#features')
                ?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            <Globe className="size-3" />
            Status
          </a>
        </div>
      </div>
    </footer>
  );
}
